import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Button,
} from "@dune/ui";
import { ReceiptPaymentSchema } from "@dune/vars";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { useDeleteReceiptPaymentMutation } from "../../../api/queries/receipt.queries";

interface DeletePaymentReceiptModalProps {
	payment: ReceiptPaymentSchema;
	receiptId: number;
	onSuccess?: () => void;
}

const DeletePaymentReceiptModal = ({
	payment,
	receiptId,
	onSuccess,
}: DeletePaymentReceiptModalProps) => {
	const [open, setOpen] = useState(false);
	const deletePaymentMutation = useDeleteReceiptPaymentMutation();

	const handleDelete = async () => {
		try {
			await deletePaymentMutation.mutateAsync({
				paymentId: payment.id,
				receiptId,
			});

			toast.success("Le règlement a été supprimé avec succès");

			setOpen(false);
			onSuccess?.();
		} catch (error) {
			console.error("Erreur lors de la suppression du règlement:", error);
			toast.error(
				"Une erreur est survenue lors de la suppression du règlement",
			);
		}
	};

	return (
		<>
			<Button
				size="icon"
				variant="ghost"
				onClick={(e) => {
					e.stopPropagation();
					setOpen(true);
				}}
			>
				<Trash2Icon className="h-4 w-4 text-red-500" />
			</Button>
			<AlertDialog open={open} onOpenChange={setOpen}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>Êtes-vous sûr ?</AlertDialogTitle>
						<AlertDialogDescription>
							Cette action est irréversible. Le règlement de référence "
							{payment.paymentReference}" sera définitivement supprimé.
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel>Annuler</AlertDialogCancel>
						<AlertDialogAction
							onClick={handleDelete}
							disabled={deletePaymentMutation.isPending}
							className="bg-red-600 hover:bg-red-700"
						>
							{deletePaymentMutation.isPending ? "Suppression..." : "Supprimer"}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	);
};

export default DeletePaymentReceiptModal;
